import { render, staticRenderFns } from "./StorageChart.vue?vue&type=template&id=397edac1&scoped=true"
import script from "./StorageChart.vue?vue&type=script&lang=js"
export * from "./StorageChart.vue?vue&type=script&lang=js"
import style0 from "./StorageChart.vue?vue&type=style&index=0&id=397edac1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397edac1",
  null
  
)

export default component.exports